import { render, staticRenderFns } from "./TemplateGuidelines.vue?vue&type=template&id=b9285386&scoped=true"
import script from "./TemplateGuidelines.vue?vue&type=script&lang=js"
export * from "./TemplateGuidelines.vue?vue&type=script&lang=js"
import style0 from "./TemplateGuidelines.vue?vue&type=style&index=0&id=b9285386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9285386",
  null
  
)

export default component.exports